import type { ScanPhoto } from '@kaiizen/kai-scan-template-system';

import { type GalleryPhotoOccurrence, getGalleryPhotoOccurrenceKey } from '../galleryPhotoOperations';
import type { PhotoManagerSection } from '../photoManagerModel';

/** How the manager says "n photos", everywhere it says it. */
export const getPhotoCountLabel = (count: number) => `${count} photo${count === 1 ? '' : 's'}`;

/** A photo as it appears in one section — the unit selection is keyed by, since the same photo
 *  can sit in more than one place. */
export const buildOccurrence = (photo: ScanPhoto, section: PhotoManagerSection): GalleryPhotoOccurrence => ({
  key: getGalleryPhotoOccurrenceKey({ ...section.scanPartContext, photoId: photo.photoId }),
  photo,
  context: section.scanPartContext,
  sectionTitle: section.title,
});
